import styled from '@emotion/styled';
import { pixify } from '@seedlang/utils';

export const AgreementWrapper = styled.div`
  width: 100%;
`;

export const DiscordButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  height: ${props => props.mobile ? '35px' : '42px'};
  width: ${props => props.mobile ? '35px' : '42px'};
  background: #efefef;
  margin-left: ${props => props.isSeedlang ? '10px' : '15px'};
  transition: all 0.2s ease;
  color: #333333;
  text-decoration: none;

  &:hover {
    background-color: #5865F2;
    color: #FFFFFF;
  }
`;

export const Wrapper = styled.header`
  display: flex;
  z-index: 999;
  width: 100%;
  height: ${props => pixify(props.desktopHeaderHeight)};
  min-height: ${props => pixify(props.desktopHeaderHeight)};
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: ${props => props.background};
  position: ${props => props.position};
  border-bottom: ${props => props.borderBottom};
  top: 0;
  .on-click {
    cursor: pointer;
  }
  .on-click:hover {
    color: #FFF;
  }
`;

export const MembershipBanner = styled.div`
  background: ${props => props.background};
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFF;
  font-size: 16px;
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFF;
  }
  .icon-wrapper {
    margin-right: 5px;
  }
`;

export const InnerWrapper = styled.div`
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1180px;
  position: relative;
`;

export const LogoWrapper = styled.div`
  width: 190px;
  cursor: pointer;
`;

export const LinkWrapper = styled.button`
  appearance: none;
  border: none;
  background: none;
  display: ${props => props.display};
  padding-bottom: 3px;
  margin-left: 15px;
  font-size: 17px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-color: ${props => props.borderColor};
  &:hover {
    color: #000!important;
  }
`;

export const NavigationButtons = styled.nav`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const MobileNavigation = styled.div`
  position: absolute;
  width: 100%;
  background: #FFF;
  top: ${props => props.top};
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 20px 30px 20px 0;
  z-index: 99;
  border-bottom: 1px solid #b7b7b7;
`;

export const MobileIconWrapper = styled.button`
  appearance: none;
  border: none;
  background: none;
  display: flex;
  width: 50px;
  margin-left: 10px;
  .menu-icon, .close-icon {
    cursor: pointer;
    svg {
      fill: #000;
      width: 25px;
    }
  }
`;

export const Hr = styled.div`
  width: 140px;
  border-bottom: 1px solid #b7b7b7;
  height: 5px;
  margin: 10px 0;
`;
